import axios from "config/@axios";
import * as uiActions from "store/actions/uiActions";
import * as archiveActions from "pages/Archive/store/archiveActions";

export const FETCH_ARCHIVES = "archivesActions::fetchArchives";
export const FETCH_ARCHIVES_SUCCESS = "archivesActions::fetchArchivesSuccess";
export const FETCH_ARCHIVES_FAILED = "archivesActions::fetchArchivesFailed";
export const FETCH_ARCHIVES_APPEND = "archivesActions::fetchArchivesAppend";
export const FETCH_ARCHIVES_APPEND_SUCCESS =
  "archivesActions::fetchArchivesAppendSuccess";
export const FETCH_ARCHIVES_APPEND_FAILED =
  "archivesActions::fetchArchivesAppendFailed";

export const fetchByPage =
  ({ page, data }) =>
  (dispatch, getState) => {
    const state = getState();
    const perPage = state.auth.settings.display_mail_count;
    let offset;
    if (page < 1) {
      offset = 0;
    } else {
      offset = (page - 1) * perPage;
    }

    dispatch(archiveActions.setPage(page));
    return dispatch(fetchArchives({ ...data, count: perPage, start: offset }));
  };

export const fetchNextPage =
  ({ page }) =>
  (dispatch, getState) => {
    const state = getState();
    const perPage = state.auth.settings.display_mail_count;
    const offset = (page - 1) * perPage;

    dispatch(archiveActions.setPage(page));
    return dispatch(
      fetchArchives({ count: perPage, start: offset }, { append: true })
    );
  };

export const fetchArchives =
  (params = null, { append = false } = {}) =>
  (dispatch, getState) => {
    const state = getState();
    const userEmail = state.auth.user.email;
    const searchParams = state.archive.searchParams;

    const currentParams = {
      ...searchParams,
      ...params,
      archiveownermail: userEmail
    };

    if (!currentParams.starttime) {
      currentParams["starttime"] = parseInt(
        new Date().setHours(0, 0, 0) / 1000
      );
    }
    if (!currentParams.endtime) {
      currentParams["endtime"] = parseInt(
        new Date().setHours(23, 59, 59) / 1000
      );
    }
    if (!currentParams.date_type) {
      currentParams["date_type"] = "archive_date";
    }

    if (currentParams?.["date_type"] === "header_date") {
      currentParams["header_starttime"] = currentParams["starttime"];
      currentParams["header_endtime"] = currentParams["endtime"];
    }

    Object.keys(currentParams).forEach(el => {
      if (currentParams[el] === "") {
        delete currentParams[el];
      }
    });

    const fetchType = append ? FETCH_ARCHIVES_APPEND : FETCH_ARCHIVES;
    const successType = append
      ? FETCH_ARCHIVES_APPEND_SUCCESS
      : FETCH_ARCHIVES_SUCCESS;
    const failedType = append
      ? FETCH_ARCHIVES_APPEND_FAILED
      : FETCH_ARCHIVES_FAILED;

    dispatch({
      type: fetchType
    });

    return axios
      .get("archives/messages", { params: currentParams })
      .then(response => {
        const totalCount = response.headers["x-total-count"];
        dispatch({
          type: successType,
          payload: {
            archives: response.data,
            totalCount,
            perPage: currentParams.count
          }
        });
        dispatch(archiveActions.setSearchParams(currentParams));
        if (!append) {
          dispatch(uiActions.selectAll(false, "archives"));
        }
      })
      .catch(err => {
        dispatch({
          type: failedType,
          payload: {
            errorText: err.errorMessage
          }
        });
      });
  };
